import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { GlobalConfigurationApi } from '../../models/global-settings.model';
import { Security, SecurityResponse } from '../../models/security.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsService {
  private readonly API = `${environment.api_url}/globalsettings`;

  constructor(private http: HttpClient) {}

  create(body: GlobalConfigurationApi): Observable<void> {
    return this.http.post<void>(`${this.API}`, body);
  }

  update(body: GlobalConfigurationApi): Observable<void> {
    return this.http.put<void>(`${this.API}`, body);
  }

  get(): Observable<GlobalConfigurationApi> {
    return this.http.get<GlobalConfigurationApi>(`${this.API}`);
  }

  getSecurity(): Observable<SecurityResponse> {
    return this.http.get<SecurityResponse>(`${this.API}/getPassword`);
  }

  updateSecurity(body: Security): Observable<Security> {
    return this.http.put<Security>(`${this.API}/Password`, body);
  }
}
